import React from 'react';
import { useDispatch } from 'react-redux';
import { headerActions } from '@/reducers/HeaderConfigs';
import { setDocumentTitle, isEnv } from '@/utils';
import wx from '@/libs/promiseWx/wxPromisify';
interface InitProps {
  children: any; //组件
  meta?: any; //附加参数
}

const RouterAuth = (props: InitProps) => {
  const {
    children,
    meta: { title, isHeader, hideMenu },
  } = props;
  const dispatch = useDispatch();

  //设置header 标题
  dispatch(
    headerActions.setHeader({
      title,
      isHeader,
      className: '',
      theme: 'white',
      rightContent: '',
      rightClick: null,
    })
  );

  //非APP 情况下设置标题
  if (isEnv() !== 'App' && title) {
    setDocumentTitle(title);
  }

  //隐藏微信里面右上角菜单
  if (isEnv() === 'WxChat') {
    if (hideMenu) {
      wx.hideMenuItem();
    } else {
      wx.showMenuItem();
    }
  }

  return children;
};

export default RouterAuth;
